export default __webpack_public_path__ + "static/media/wave.f7b91595522709c93d3773ba92ba3e69.png";